import { LOCAL_SUBSTRATE_MANIFEST } from './localManifest';
import type { ManifestSource, ManifestSourceResult } from './types';

export class LocalManifestSource implements ManifestSource {
  id(): string {
    return 'local-v1';
  }

  async load(): Promise<ManifestSourceResult> {
    return {
      manifest: LOCAL_SUBSTRATE_MANIFEST,
      source: this.id(),
      loadedAt: new Date(),
    };
  }
}
